<template>
  <el-dialog
    :title="model.id ? '编辑成品分类' : '添加成品分类'"
    :visible.sync="visible"
    width="900px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="110px"
      size="small"
    >
      <el-form-item label="名称：" prop="name">
        <el-input v-model.trim="model.name"></el-input>
      </el-form-item>
      <el-form-item label="所属分组：" prop="template_group_id" v-if="visible">
        <TemplateGroupSelect
          v-model="model.template_group_id"
          :type="model.category"
          :codeType="model.code_type"
        ></TemplateGroupSelect>
      </el-form-item>
      <el-form-item
        label="下属分组："
        prop="children_groups"
        v-if="model.code_type == 1"
      >
        <el-input
          v-model.trim="model.children_groups"
          placeholder='多个分组请用顿号"、"分隔'
        ></el-input>
      </el-form-item>
      <el-form-item
        label="固定配件："
        prop="item_ids"
        v-if="model.code_type == 1"
      >
        <Item-select
          v-model="model.item_template_ids"
          :category="model.category"
          :multiple="true"
        ></Item-select>
      </el-form-item>
      <el-form-item label="是否固定资产：" prop="asset_type">
        <el-select size="small" v-model="model.asset_type">
          <el-option key="1" :value="1" label="否"></el-option>
          <el-option key="2" :value="2" label="是"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="寿命预警条件："
        v-if="model.category == 2 && model.code_type == 1"
      >
        最近一次维修后：
        <el-input
          size="small"
          v-model.number="model.warning_current_day"
          style="width: 200px"
          ><template slot="prepend">寿命值达到</template
          ><template slot="append">天</template></el-input
        >
        <el-select
          size="small"
          v-model="model.warning_condition_type"
          placeholder=""
          style="width: 60px; margin: 0 5px"
        >
          <el-option key="1" :value="1" label="或"></el-option>
          <el-option key="2" :value="2" label="且"></el-option>
        </el-select>
        <el-input
          size="small"
          v-model.number="model.warning_current_hour"
          style="width: 240px"
          ><template slot="prepend">工作时长达到</template
          ><template slot="append">小时</template></el-input
        >
      </el-form-item>
      <el-form-item label="固定属性：">
        <el-breadcrumb separator="|" style="line-height: 32px">
          <el-breadcrumb-item>{{
            model.code_type == 1 ? '编号' : '编码'
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>状态</el-breadcrumb-item>
          <el-breadcrumb-item>备注</el-breadcrumb-item>
        </el-breadcrumb>
      </el-form-item>
      <el-form-item label="自定义属性：">
        <template slot-scope>
          <div
            v-if="
              model.custom_params &&
              model.custom_params.filter((item) => !!item.label).length == 0
            "
          >
            无
          </div>
          <el-breadcrumb separator="|" style="line-height: 32px" v-else>
            <el-breadcrumb-item
              v-for="item in model.custom_params"
              :key="item.label"
              >{{ item.label }}</el-breadcrumb-item
            >
          </el-breadcrumb>
        </template>
      </el-form-item>
      <draggable :list="model.custom_params">
        <el-form-item
          v-for="(param, index) in model.custom_params"
          :label="`属性${index + 1}：`"
          class="drag"
          :key="index"
        >
          <template #label>
            <span style="cursor: move"> 属性{{ index + 1 }}： </span></template
          >
          <div style="display: flex">
            <el-input
              v-model="param.label"
              placeholder="属性名称"
              style="width: 177px; min-width: 177px"
            ></el-input>
            <el-select
              class="ml-5"
              v-model="param.type"
              placeholder="属性类型"
              style="width: 100px; min-width: 100px"
            >
              <el-option key="1" :value="1" label="文本输入"></el-option>
              <el-option key="2" :value="2" label="日期选择"></el-option>
              <el-option key="3" :value="3" label="下拉选择"></el-option>
            </el-select>
            <el-input
              v-if="param.type == 3"
              class="ml-5"
              v-model="param.options"
              placeholder='选项值（多个选项值用顿号"、"分隔）'
            ></el-input>
            <el-checkbox
              class="ml-10"
              style="margin-right: 0; margin-bottom: 0"
              border
              :value="param.model_alias"
              @change="handleModelFieldChange(index)"
              >规格型号别名</el-checkbox
            >
            <el-button
              class="ml-10"
              @click="model.custom_params.splice(index, 1)"
              >删除</el-button
            >
          </div>
        </el-form-item>
      </draggable>
      <el-form-item>
        <el-button
          size="mini"
          type="primary"
          @click="
            model.custom_params.push({
              key: `custom${model.custom_params.length}`,
              label: '',
              type: 1,
              options: '',
              value: '',
            })
          "
          >添加</el-button
        >
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="submitForm"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { productTemplateNew, productTemplateUpdate } from '@/service/getData'
import ItemSelect from '@/components/select/item_template_multiple_select'
import TemplateGroupSelect from '@/components/select/template_group_select.vue'
import draggable from 'vuedraggable'

export default {
  components: {
    ItemSelect,
    TemplateGroupSelect,
    draggable,
  },
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
        this.model.custom_params = []
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        name: [{ required: true, message: '请填写名称' }],
        template_group_id: [{ required: true, message: '请选择分组' }],
      },
    }
  },
  methods: {
    handleModelFieldChange(index) {
      let checked = this.model.custom_params[index].model_alias
      if (checked) {
        index = -1
      }
      this.model.custom_params.map((param, idx) => {
        this.$set(this.model.custom_params[idx], 'model_alias', idx == index)
      })
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          data.custom_params = data.custom_params.filter((item) => item.label)
          if (this.model.id > 0) {
            let res = await productTemplateUpdate(data)
            if (res.status == 0) {
              this.$emit('updated', res.data)
            }
          } else {
            let res = await productTemplateNew(data)
            if (res.status == 0) {
              this.$emit('created', res.data)
            }
          }
          this.visible = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>